import Vue from 'vue'
import Vuex from 'vuex'

import http from './services/axios'
import CookieService from './services/cookies'
import lodash from './services/lodash'

import helpers from './services/helpers'
import {
    LANGUAGE_COOKIE_KEY,
    SESSION_COOKIE_KEY,
    AUTH_HEADER_TOKEN,
    GET_UI_TEXT_BY_KEY,
    SET_SESSION,
    SET_MASECHTOT,
    SET_SEDARIM,
    SET_TALMUD_PRODUCTS,
    SET_LANGUAGE,
    SET_UI_TEXT,
    SET_USER,
    LOAD_LANGUAGE_FROM_COOKIE,
    LOAD_SESSION_FROM_COOKIE,
    LOAD_USER,
    LOAD_SEDARIM,
    LOAD_MASECHTOT,
    LOAD_TALMUD_PRODUCTS,
    LOAD_UI_TEXT,
    INIT_STORE,
    LOADING_PRISTINE,
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
    LOADING_COMPLETED_FAILURE,
    SET_LANGUAGE_AND_RELOAD,
    LOGOUT,
    SET_BOOK_PRODUCTS,
    LOAD_BOOK_PRODUCTS,
    ADD_PRODUCT_TO_CART,
    INIT_ADDED_TO_CART_MODAL,
    SHOW_ADDED_TO_CART_MODAL,
    ADD_TO_CART,
    ADD_MULTIPLE_TO_CART,
    REMOVE_FROM_CART_BY_INDEX,
    UPDATE_PRODUCT_QUANTITY_BY_INDEX,
    EVENT_SHOW_STATE,
    LOAD_USER_EVENTS,
    CLEAR_PRESELECTED_DAF,
    READ_AND_CLEAR_PRESELECTED_DAF,
    SET_PRESELECTED_DAF,
    SET_DAY_LESSON_MAP,
    LOAD_DAY_LESSON_MAP,
    DAY_LESSON_CSV_URL,
    SET_TODAYS_LESSON,
    LOAD_TODAYS_LESSON,
    LOAD_USER_ATTRIBUTES,
    UPDATE_PRODUCT_VARIANT_BY_INDEX,
    LOAD_DYNAMIC_PROFILE_PHOTOS,
    SET_DYNAMIC_PROFILE_PHOTOS,
    GET_PROFILE_PHOTOS_LIST,
    SET_SIGNUP_SHOW_STATE,
    SIGN_UP_MODE,
    SET_SIGNUP_MODE,
    SET_THANK_YOU_POPUP_SHOW_STATE,
    GET_SEARCH_PARAMS_CONTENT_TYPE_LESSON,
    GET_BODY_TEXT_BY_KEY, SET_BODY_TEXT, LOAD_BODY_TEXT, GET_LOGGED_IN, PRE_INIT_STORE,
    A_AFTER_NAVIGATION,
    A_AFTER_NAVIGATION_LESSON_MODULE,
} from './services/constants'

import {user} from './store-modules/user'
import {lesson} from './store-modules/lesson'
import {searchModule} from './store-modules/search'
import {integrationsModule} from './store-modules/integrations'

Vue.use(Vuex)

const languageStoreModule = {
    state: {
        languages: [
            {
                locale: 'es',
                displayName: 'Spanish',
            },
            {
                locale: 'en',
                displayName: 'English',
            },
        ],
        currentLanguage: null,
        uiText: {
            state: LOADING_PRISTINE,
            data: [],
            error: null,
        },
        bodyText: {
            state: LOADING_PRISTINE,
            data: [],
            error: null,
        },
    },
    getters: {
        [GET_UI_TEXT_BY_KEY]: (state) => (key) => {
            const result = state.uiText.data.find(uiTextItem => uiTextItem.key === key)
            return result ? result : null
        },
        [GET_BODY_TEXT_BY_KEY]: (state) => (key) => {
            const result = state.bodyText.data.find(bodyTextItem => bodyTextItem.key === key)
            return result ? result : null
        },
    },
    mutations: {
        [SET_LANGUAGE]: (state, payload) => {
            state.currentLanguage = lodash.cloneDeep(payload)
            if (state.currentLanguage) {
                CookieService.set(LANGUAGE_COOKIE_KEY, payload)
            } else {
                CookieService.removeByKey(LANGUAGE_COOKIE_KEY)
            }
        },
        [SET_UI_TEXT]: (state, payload) => {
            state.uiText = lodash.cloneDeep(payload)
        },
        [SET_BODY_TEXT]: (state, payload) => {
            state.bodyText = lodash.cloneDeep(payload)
        },
        [LOAD_LANGUAGE_FROM_COOKIE]: (state) => {
            const cookieResult = JSON.parse(CookieService.getByKey(LANGUAGE_COOKIE_KEY));
            if (cookieResult) {
                state.currentLanguage = cookieResult;
            } else {
                state.currentLanguage = lodash.cloneDeep(state.languages[0])
            }
        },
    },
    actions: {
        [SET_LANGUAGE_AND_RELOAD]: (context, payload) => {
            context.commit(SET_LANGUAGE, payload)
            context.dispatch(LOAD_SEDARIM)
            context.dispatch(LOAD_MASECHTOT)
            context.dispatch(LOAD_UI_TEXT)
            context.dispatch(LOAD_BODY_TEXT)
        },
        [LOAD_UI_TEXT]: (context) => {
            context.commit(SET_UI_TEXT, {
                state: LOADING_STARTED,
                data: [],
                error: null,
            });
            const config = {
                params: {
                    language: context.state.currentLanguage.locale
                }
            }
            http.getDelivery(`entries?contentType=ui_text`, config).then(results => {
                const mappedResults = results.data.map(entry => {
                    return helpers.mapEntry(entry)
                })
                context.commit(SET_UI_TEXT, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: mappedResults,
                    error: null,
                });
            }).catch(err => {
                context.commit(SET_UI_TEXT, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: [],
                    error: err,
                });
            })
        },
        [LOAD_BODY_TEXT]: (context) => {
            context.commit(SET_BODY_TEXT, {
                state: LOADING_STARTED,
                data: [],
                error: null,
            });
            const config = {
                params: {
                    language: context.state.currentLanguage.locale
                }
            }
            http.getDelivery(`entries?contentType=body_text`, config).then(results => {
                const mappedResults = results.data.map(entry => {
                    return helpers.mapEntry(entry)
                })
                context.commit(SET_BODY_TEXT, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: mappedResults,
                    error: null,
                });
            }).catch(err => {
                context.commit(SET_BODY_TEXT, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: [],
                    error: err,
                });
            })
        },
    }
}

const commerceModule = {
    state: {
        talmudProducts: {
            state: LOADING_PRISTINE,
            data: null,
            error: null,
        },
        bookProducts: {
            state: LOADING_PRISTINE,
            data: null,
            error: null,
        },
        preselectedDaf: {
            data: null,
        },
        cart: {
            data: [],
        },
        // cartItemExample: {
        //     productId: 32,
        //     name: 'Brachos',
        //     variant: 'Large',
        //     price: 15,
        //     quantity: 1,
        // },
        addedToCartModal: {
            ref: null,
            props: {
                showing: false,
                cartItem: {},
            }
        },
        masechetNamePrefix: 'Masechet',
        dafPrefix: 'Daf',
        allOfMasechet: 'All',

    },
    mutations: {
        [CLEAR_PRESELECTED_DAF]: (state) => {
            state.preselectedDaf.data = null
        },
        [SET_PRESELECTED_DAF]: (state, payload) => {
            state.preselectedDaf.data = payload
        },
        [INIT_ADDED_TO_CART_MODAL]: (state, payload) => {
            state.addedToCartModal.ref = payload
            state.addedToCartModal.ref.$on(EVENT_SHOW_STATE, ($event) => {
                state.addedToCartModal.props.showing = $event
                state.addedToCartModal.props.cartItem = {}
            })
        },
        [SHOW_ADDED_TO_CART_MODAL]: (state, payload) => {
            state.addedToCartModal.props.showing = true
            state.addedToCartModal.props.cartItem = lodash.cloneDeep(payload)
        },
        [SET_TALMUD_PRODUCTS]: (state, payload) => {
            state.talmudProducts = lodash.cloneDeep(payload)
        },
        [SET_BOOK_PRODUCTS]: (state, payload) => {
            state.bookProducts = lodash.cloneDeep(payload)
        },
        [ADD_PRODUCT_TO_CART]: (state, payload) => {
            state.cart.data.push(lodash.cloneDeep(payload))
        },
        [REMOVE_FROM_CART_BY_INDEX]: (state, index) => {
            state.cart.data.splice(index, 1)
        },
        [UPDATE_PRODUCT_QUANTITY_BY_INDEX]: (state, payload) => {
            state.cart.data[payload.index].quantity = payload.quantity
        },
        [UPDATE_PRODUCT_VARIANT_BY_INDEX]: (state, payload) => {
            state.cart.data[payload.index].variant = payload.variant
            state.cart.data[payload.index].unitPrice = payload.unitPrice
        },
    },
    // getters: {
    //     [GET_PRODUCT_BY_ID]: (state) => (id) => {
    //         if (state.talmudProducts.data) {
    //             const result = state.talmudProducts.data.find(product => product.id === id)
    //             return result ? result : null
    //         } else {
    //             return null
    //         }
    //     }
    // },
    actions: {
        [LOAD_TALMUD_PRODUCTS]: (context) => {
            if (context.state.talmudProducts.data) {
                return
            }
            context.commit(SET_TALMUD_PRODUCTS, {
                state: LOADING_STARTED,
                data: null,
                error: null,
            });
            const config = {
                params: {
                    contentType: 'product',
                    category: '51',
                    language: context.rootState.languageModule.currentLanguage.locale
                }
            }
            http.getDelivery(`entries`, config).then(results => {
                const mappedResults = results.data.map(entry => {
                    return helpers.mapEntry(entry)
                })
                context.commit(SET_TALMUD_PRODUCTS, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: mappedResults,
                    error: null,
                });
            }).catch(err => {
                context.commit(SET_TALMUD_PRODUCTS, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: err,
                });
            })
        },
        [LOAD_BOOK_PRODUCTS]: (context) => {
            if (context.state.bookProducts.data) {
                return
            }
            context.commit(SET_BOOK_PRODUCTS, {
                state: LOADING_STARTED,
                data: null,
                error: null,
            });
            const config = {
                params: {
                    contentType: 'product',
                    category: '30',
                    language: context.rootState.languageModule.currentLanguage.locale
                }
            }
            http.getDelivery(`entries`, config).then(results => {
                const mappedResults = results.data.map(entry => {
                    return helpers.mapEntry(entry)
                })
                context.commit(SET_BOOK_PRODUCTS, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: mappedResults,
                    error: null,
                });
            }).catch(err => {
                context.commit(SET_BOOK_PRODUCTS, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: err,
                });
            })
        },
        [ADD_TO_CART]: (context, payload) => {
            //    do some state stuff
            context.commit(ADD_PRODUCT_TO_CART, payload)
            //     show the thing added to the state in the added to cart modal
            context.commit(SHOW_ADDED_TO_CART_MODAL, payload)
        },
        [ADD_MULTIPLE_TO_CART]: (context, payload) => {
            //    do some state stuff
            const fakeAggregateProductForCart = {
                productId: null,
                item: '',
                name: '',
                variant: '',
                unitPrice: 0,
                quantity: 0,
            }
            if (Array.isArray(payload)) {
                payload.forEach((product, i) => {
                    if (i === 0) {
                        fakeAggregateProductForCart.name = product.name
                        fakeAggregateProductForCart.item = product.item
                    }
                    fakeAggregateProductForCart.variant += `${product.variant}, `
                    fakeAggregateProductForCart.unitPrice += product.unitPrice
                    fakeAggregateProductForCart.quantity += product.quantity
                    context.commit(ADD_PRODUCT_TO_CART, product)
                })
            }
            //     show the aggregate data in the added to cart modal
            fakeAggregateProductForCart.variant =
                fakeAggregateProductForCart.variant.substring(0, fakeAggregateProductForCart.variant.length - 2)
            context.commit(SHOW_ADDED_TO_CART_MODAL, fakeAggregateProductForCart)
        },
        [READ_AND_CLEAR_PRESELECTED_DAF]: (context) => {
            const preselectedDaf = context.state.preselectedDaf.data
            context.commit(CLEAR_PRESELECTED_DAF)
            return preselectedDaf
        },
    }
}

export default new Vuex.Store({
    modules: {
        languageModule: languageStoreModule,
        commerceModule: commerceModule,
        lessonModule: lesson,
        searchModule: searchModule,
        userModule: user,
        integrationsModule,
    },
    state: {
        videoVisible: false,
        tools: [
            {
                icon: 'hands.svg',
                title: 'Jabruta online',
                showImg: false,
                video: 'https://youtube.com/embed/FjpCCEnceNU',
                mobileText: 'Encuentra tu compañero de estudios ideal entre los miles de usuarios de Jabrutouch.',
                queEs: '<p>Estudiar por videoconferencia ya no es ninguna novedad, sin embargo, con esta nueva herramienta Jabrutouch da un salto cualitativo. A partir de ahora, tendrás dos formas de elegir un compañero de estudios online: <b>búsqueda inteligente</b> o <b>búsqueda dirigida</b>.</p><p>La búsqueda inteligente localiza al instante la Jabruta que más se ajusta a tu perfil, mientras que la búsqueda dirigida te dará a elegir entre varios niveles de Jabruta. En ambos casos, la app te conectará al instante con tu Jabruta eligiendo entre los miles de usuarios del Jabrutouch.</p>',
            },
            {
                icon: 'chat.svg',
                title: 'Consulta al Rab',
                showImg: false,
                video: 'https://youtube.com/embed/iGfujo8NFgM',
                mobileText: 'Elige entre un amplio plantel de Rabanim listos para responder a todas tus preguntas al momento.',
                queEs: '<p>¿Te imaginas disponer en todo momento de un Rab al que dirigir tus preguntas por videoconferencia?  Esta innovadora herramienta pone a tu alcance un enorme plantel de Rabanim listos para responder al momento tus preguntas sobre el Talmud. Podrás elegir entre los Rabanim que se encuentren disponibles al momento de formular tu pregunta. Tú decides cuándo y a quién preguntar.<p>',
            },
            {
                icon: 'coaching.png',
                title: 'Coaching',
                showImg: false,
                video: 'https://youtube.com/embed/vaI98Xcq3EQ',
                mobileText: 'Profesionales gratuitos o de pago para acompañarte en todo tu proceso de estudio.',
                queEs: '<p>El coaching ya está de moda, pero sus ventajas para el crecimiento en el estudio del Talmud no ha hecho más que empezar. La misión del coach será tanto ayudarte a entender una Guemará por ti mismo, como asegurarte de cómo obtener placer al estudiarla. Además, tendrás a tu disposición varios Rabanim y profesionales para elegir. Unos serán gratuitos y otros no.</p>',
            },
            {
                icon: 'my-jabrutouch.svg',
                title: 'My Jabrutouch',
                showImg: false,
                video: 'https://youtube.com/embed/x8pw79Qktd0',
                mobileText: 'Diseña tu propio plan de estudio para disfrutar la dosis perfecta de Torá cada día.',
                queEs: '<p>Hasta ahora, Jabrutouch se ha comportado como una enorme videoteca de <i>Shiurim</i> sobre el Talmud. El único programa que tenía por defecto era el del Daf Hayomi mundial. Por eso, la app  sincroniza automáticamente el shiur correspondiente al DAF de ese día.</p><p>A partir de ahora, tú podrás decidir qué quieres estudiar. Esta nueva herramienta te ofrecerá cada día la dosis de Torá adecuada para que se ajuste al plan de estudio que tú elijas.</p>',
            },
            {
                icon: 'book.svg',
                title: 'Otsar Hajojmá y Jabrutouch',
                showImg: false,
                video: 'https://youtube.com/embed/WXaJi2iS5w0',
                mobileText: 'La biblioteca más grande del mundo a tu alcance gracias a su alianza con Jabrutouch.',
                queEs: '<p>La biblioteca más grande del mundo está ahora a tu alcance a través de Jabrutouch. Búsqueda de Mekorot, comentarios diversos y Shutim, son solo algunas de las fuentes rabínicas a las que tendrás acceso con esta novedosa colaboración entre Otsar Hajojmá y Jabrutouch.</p>',
            },
            {
                icon: 'interactive.png',
                title: 'Seguimiento visual del Shiur',
                showImg: false,
                video: 'https://youtube.com/embed/Z423_NDZdC4',
                mobileText: 'Marca el texto a medida que avanza el shiur, y controla el video a través del texto.',
                queEs: '<p>¿Qué parte del texto se está explicando? ¿Por dónde va? Estas preguntas nos surgen a menudo cuando estudiamos siguiendo el video de Jabrutouch. La nueva generación del Jabrutouch contempla marcar visualmente el texto original del pdf en pantalla a medida que avanza el shiur. Además, podrás controlar el video a través del texto y viceversa.</p>',
            },
            {
                icon: 'search.svg',
                title: 'Concordatsia: búsqueda inteligente',
                showImg: false,
                video: 'https://youtube.com/embed/pI4Vs-iqHGk',
                mobileText: 'Nuevo sistema de búsqueda inteligente para encontrar el tema que estás buscando.',
                queEs: '<p>¿Quieres saber en qué lugares del Talmud se habla sobre la pena de muerte? ¿o dónde habla sobre los fenómenos naturales? Esta nueva herramienta te llevará al minuto exacto del video y del texto donde se mencionan esos temas. Podrás resolver estas y muchas más preguntas gracias a la nueva función de Concordatsia.</p>',
            },
        ],
        session: {
            state: LOADING_PRISTINE,
            data: null,
            error: null,
        },
        user: {
            state: LOADING_PRISTINE,
            data: null,
            error: null,
        },
        dayLessonMap: {
            state: LOADING_PRISTINE,
            data: null,
            error: null,
        },
        todaysLesson: {
            state: LOADING_PRISTINE,
            data: null,
            error: null,
        },
        sedarim: {
            state: LOADING_PRISTINE,
            data: [],
            error: null,
        },
        masechtot: {
            state: LOADING_PRISTINE,
            data: [],
            error: null,
        },
        profilePhotos: {
            state: LOADING_PRISTINE,
            data: [],
            error: null,
        },
        signUpState: {
            showState: false,
            mode: SIGN_UP_MODE,
        },
        thankYouPopup: {
            showState: false,
        },
    },
    getters: {
        [GET_PROFILE_PHOTOS_LIST]: (state) => {
            const desiredNumberOfPhotos = 7
            const totalPhotos = state.profilePhotos.data.length
            const arr = []
            if (totalPhotos === 0) {
                return arr
            } else if (totalPhotos === desiredNumberOfPhotos) {
                return state.profilePhotos.data
            } else if (totalPhotos > desiredNumberOfPhotos || totalPhotos < desiredNumberOfPhotos) {
                for (let i = 0; i < desiredNumberOfPhotos; i++) {
                    const item = state.profilePhotos.data[Math.floor(Math.random() * state.profilePhotos.data.length)];
                    arr.push(item)
                }
                return arr
            } else {
                return arr
            }
        },
        [GET_LOGGED_IN]: (state) => {
            return !!state.session.data
        },
    },
    mutations: {
        [SET_SESSION]: (state, payload) => {
            state.session = lodash.cloneDeep(payload)
            if (state.session.data) {
                CookieService.set(SESSION_COOKIE_KEY, state.session.data)
            } else {
                CookieService.removeByKey(SESSION_COOKIE_KEY)
            }
        },
        [SET_USER]: (state, payload) => {
            state.user = lodash.cloneDeep(payload)
        },
        [SET_DAY_LESSON_MAP]: (state, payload) => {
            state.dayLessonMap = lodash.cloneDeep(payload)
        },
        [SET_TODAYS_LESSON]: (state, payload) => {
            state.todaysLesson = lodash.cloneDeep(payload)
        },
        [LOAD_SESSION_FROM_COOKIE]: (state) => {
            state.session = {
                state: LOADING_PRISTINE,
                data: CookieService.getByKey(SESSION_COOKIE_KEY),
                error: null,
            }
        },
        [SET_MASECHTOT]: (state, payload) => {
            state.masechtot = payload
            if (state.masechtot.data === undefined) {
                state.masechtot.data = []
            }
            if (state.masechtot.error === undefined) {
                state.masechtot.error = null
            }
        },
        [SET_SEDARIM]: (state, payload) => {
            state.sedarim = payload
            if (state.sedarim.data === undefined) {
                state.sedarim.data = []
            }
            if (state.sedarim.error === undefined) {
                state.sedarim.error = null
            }
        },
        [SET_DYNAMIC_PROFILE_PHOTOS]: (state, payload) => {
            state.profilePhotos = lodash.cloneDeep(payload)
        },
        [SET_SIGNUP_SHOW_STATE]: (state, payload) => {
            state.signUpState.showState = payload
        },
        [SET_SIGNUP_MODE]: (state, payload) => {
            state.signUpState.mode = payload
        },
        [SET_THANK_YOU_POPUP_SHOW_STATE]: (state, payload) => {
            state.thankYouPopup.showState = payload
        },
    },
    actions: {
        [PRE_INIT_STORE]: (context) => {
            context.commit(LOAD_LANGUAGE_FROM_COOKIE)
            context.commit(LOAD_SESSION_FROM_COOKIE)
        },
        [INIT_STORE]: (context) => {
            context.dispatch(LOAD_DAY_LESSON_MAP)
            context.dispatch(LOAD_SEDARIM)
            context.dispatch(LOAD_MASECHTOT)
            context.dispatch(LOAD_UI_TEXT)
            context.dispatch(LOAD_BODY_TEXT)
            context.dispatch(LOAD_DYNAMIC_PROFILE_PHOTOS)
            if (context.state.session.data) {
                context.dispatch(LOAD_USER)
                context.dispatch(LOAD_USER_EVENTS)
                context.dispatch(LOAD_USER_ATTRIBUTES)
            }
        },
        [LOAD_DAY_LESSON_MAP]: (context) => {
            context.commit(SET_DAY_LESSON_MAP, {
                state: LOADING_STARTED,
            });
            const config = {
                params: {
                    language: context.state.languageModule.currentLanguage.locale
                }
            }
            http.getAbsolute(DAY_LESSON_CSV_URL).then(results => {
                const map = results.data.split("\n").slice(1).map(line => {
                    return line.split(',')
                }).filter(row => {
                    return !row.some(column => {
                        return column === ''
                    }) && row.length === 5
                }).map(row => {
                    const dateStringArray = row[0].split('-').map(val => {
                        return Number(val)
                    })
                    const d = new Date(dateStringArray[0], dateStringArray[1] - 1, dateStringArray[2])
                    const n = Number(row[4].trim())
                    return [d, n]
                })
                context.commit(SET_DAY_LESSON_MAP, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: map,
                    error: null,
                });

                context.dispatch(LOAD_TODAYS_LESSON)
            }).catch(err => {
                console.log(err)
                context.commit(SET_DAY_LESSON_MAP, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: err,
                });
            })
        },
        [LOAD_TODAYS_LESSON]: (context) => {
            const startOfToday = new Date()
            startOfToday.setHours(0, 0, 0, 0)
            const todayMap = context.state.dayLessonMap.data.find(dayMap => {
                return dayMap[0].getTime() === startOfToday.getTime()
            })
            if (todayMap) {
                context.commit(SET_TODAYS_LESSON, {
                    state: LOADING_STARTED,
                    data: null,
                    error: null,
                })
                const config = {
                    params: {
                        language: context.state.languageModule.currentLanguage.locale,
                        'contentType': 'lesson',
                        'number': todayMap[1],
                    }
                }
                http.getDelivery('entries', config).then(results => {
                    const mappedResults = results.data.map(entry => {
                        return helpers.mapEntry(entry)
                    })
                    context.commit(SET_TODAYS_LESSON, {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: mappedResults && mappedResults.length > 0 ? mappedResults[0] : null,
                        error: null,
                    })
                }).catch(err => {
                    console.log(err)
                    context.commit(SET_TODAYS_LESSON, {
                        state: LOADING_COMPLETED_FAILURE,
                        data: null,
                        error: err.message,
                    });
                })
            }
        },
        [LOAD_SEDARIM]: (context) => {
            context.commit(SET_SEDARIM, {
                state: LOADING_STARTED,
            });
            const config = {
                params: {
                    language: context.state.languageModule.currentLanguage.locale
                }
            }
            http.getDelivery(`entries?contentType=seder`, config).then(results => {
                const mappedResults = results.data.map(entry => {
                    return helpers.mapEntry(entry)
                })
                mappedResults.sort(helpers.sortEntriesByFactory('order'))
                context.commit(SET_SEDARIM, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: mappedResults
                });
            }).catch(err => {
                console.log(err)
                context.commit(SET_SEDARIM, {
                    state: LOADING_COMPLETED_FAILURE,
                    error: err,
                });
            })
        },
        [LOAD_MASECHTOT]: (context) => {
            context.commit(SET_MASECHTOT, {
                state: LOADING_STARTED,
            });
            const config = {
                params: {
                    language: context.state.languageModule.currentLanguage.locale
                }
            }
            http.getDelivery(`entries?contentType=masechet`, config).then(results => {
                const mappedResults = results.data.map(entry => {
                    return helpers.mapEntry(entry)
                })
                mappedResults.sort(helpers.sortMasechtot)
                context.commit(SET_MASECHTOT, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: mappedResults
                });
            }).catch(err => {
                context.commit(SET_MASECHTOT, {
                    state: LOADING_COMPLETED_FAILURE,
                    error: err,
                });
            })
        },
        [LOAD_DYNAMIC_PROFILE_PHOTOS]: (context) => {
            context.commit(SET_DYNAMIC_PROFILE_PHOTOS, {
                state: LOADING_STARTED,
                data: context.state.profilePhotos,
                error: context.state.error
            });
            const config = {
                params: {
                    language: context.state.languageModule.currentLanguage.locale
                }
            }

            http.getDelivery(`entries?contentType=home_page_profile`, config).then(results => {
                const mappedResults = results.data.map(entry => {
                    return helpers.mapEntry(entry)
                })
                context.commit(SET_DYNAMIC_PROFILE_PHOTOS, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: mappedResults,
                    error: null,
                });
            }).catch(err => {
                context.commit(SET_DYNAMIC_PROFILE_PHOTOS, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: [],
                    error: err,
                });
            })
        },
        [LOAD_USER]: (context) => {
            context.commit(SET_USER, {
                state: LOADING_STARTED,
                data: null,
                error: null,
            });
            const config = {
                headers: {
                    [AUTH_HEADER_TOKEN]: `Bearer ${context.state.session.data}`
                }
            }
            return http.get(`users/current`, config).then(results => {
                http.getUserFromAppServer(results.data.emailAddress).then(results => {
                    if (!results.data){
                        logout()
                    }
                    });

                context.commit(SET_USER, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: results.data,
                    error: null,
                });
            }).catch(err => {
                context.commit(SET_USER, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: err.message,
                });
            })
        },
        [LOGOUT]: (context) => {
            context.commit(SET_USER, {
                state: LOADING_PRISTINE,
                data: null,
                error: null,
            },);
            context.commit(SET_SESSION, {
                state: LOADING_PRISTINE,
                data: null,
                error: null,
            });

        },
        [A_AFTER_NAVIGATION]: (context, toRoute) => {
            return Promise.all([
                context.dispatch(A_AFTER_NAVIGATION_LESSON_MODULE, toRoute)
            ])
        }
    }
})
